import { render, staticRenderFns } from "./CandidatesList.vue?vue&type=template&id=0af7fe1a&scoped=true"
import script from "./CandidatesList.vue?vue&type=script&lang=js"
export * from "./CandidatesList.vue?vue&type=script&lang=js"
import style0 from "./CandidatesList.vue?vue&type=style&index=0&id=0af7fe1a&prod&scoped=true&lang=css"
import style1 from "./CandidatesList.vue?vue&type=style&index=1&id=0af7fe1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7fe1a",
  null
  
)

export default component.exports